import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { Modals } from '../../../constants/ScreenNames';
import WrapBottomColor from '../../containers/WrapBottomColor';
import BottomButton from '../../BottomButton';
import BaseText from '../../BaseText';
import RowView from '../../RowView';
import { Color, CommonProperties, CommonStyles } from '../../../styles';
import { Checkbox } from '../../Checkbox';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllGroupedEvents } from '../../../store/selectors/events.selector';
import { selectReceipt } from '../../../store/selectors/mytrips.selector';
import { setSelectedEvent } from '../../../store/actions/events';
import { openAlert } from '../../../store/actions/alert';

const MeetingModal = () => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const [selectedActivity, setSelectedActivity] = useState(null);
  const receiptResponse = useSelector(selectReceipt);
  const groupedEvents = useSelector(
    selectAllGroupedEvents(receiptResponse.FromDate, receiptResponse.ToDate, true)
  );

  const onEdit = () => {
    if (selectedActivity) {
      dispatch(setSelectedEvent(selectedActivity));
      navigation.navigate(Modals.MeetingFormModal, { trip: receiptResponse });
    } else {
      dispatch(openAlert({ message: 'You need to select at least one item to edit' }));
    }
  };

  return (
    <WrapBottomColor disabled={!selectedActivity}>
      <View style={styles.container}>
        {Object.keys(groupedEvents).map((section) => (
          <View key={section}>
            <BaseText style={[CommonStyles.mb3, CommonStyles.small, { color: '#808285' }]}>
              {section}
            </BaseText>
            {groupedEvents[section]
              .filter((item) => !item.notEditable)
              .map((item) => (
                <RowView style={[CommonStyles.centerItems, CommonStyles.mb3]} key={item.Title}>
                  <TouchableOpacity onPress={() => setSelectedActivity(item)}>
                    <Checkbox size={15} selected={item.Title === selectedActivity?.Title} />
                  </TouchableOpacity>
                  <BaseText style={CommonStyles.ml3}>{item.Title}</BaseText>
                </RowView>
              ))}
          </View>
        ))}
      </View>
      <BottomButton disabled={!selectedActivity} label="Edit" full onPress={onEdit} />
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.accent,
    ...CommonProperties.py3,
    ...CommonProperties.px5,
  },
});

export default MeetingModal;
